import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Enturmacao } from '../../services/mobile-frequencia.service';
import { getButtonClassDia, getNomeAluno, getStatusLabelDia } from '../../utils/mobile-frequencia-aluno-card.utils';

/**
 * Card de um aluno na lista de frequência por dia (mobile-frequencia). UI pura —
 * o estado de "alterando" (loading do botão) e a contagem de abonos/justificativas
 * são calculados pelo pai (dependem de Maps de estado compartilhados entre alunos)
 * e recebidos aqui via @Input.
 */
@Component({
  selector: 'app-mobile-frequencia-aluno-card-dia',
  templateUrl: './mobile-frequencia-aluno-card-dia.component.html'
})
export class MobileFrequenciaAlunoCardDiaComponent {
  @Input() aluno!: Enturmacao;
  @Input() numero = 0;
  @Input() aulaRealizada = false;
  @Input() alterando = false;
  @Input() abonosJustificativasCount = 0;

  @Output() togglePresenca = new EventEmitter<Enturmacao>();
  @Output() abrirAbonosJustificativas = new EventEmitter<Enturmacao>();

  get nomeAluno(): string {
    return getNomeAluno(this.aluno);
  }

  get buttonClassDia(): string {
    return getButtonClassDia(this.aluno, this.aulaRealizada);
  }

  get statusLabelDia(): string {
    return getStatusLabelDia(this.aluno, this.aulaRealizada);
  }
}
